import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Loading, NewFooter } from "../../../components";
import { func } from "../../../utils";
import { SwooshSVG } from "../../JadwalPertandingan/JadwalPertandingan.styled";

import Section from "../../../components/atoms/Section";
import useWindowSize from "../../../hooks/useWindowSize";
import {
  ContentWrapper,
  InnerContentWrapper,
} from "./KlasemenPertandingan.styled";
import GroupTable from "./components/GroupTable";
import dummyData from "./dummy-data.json";
import {
  useFetchClassmentsDetails,
  useFetchClassmentsDetailsV2,
  useFetchRegionEventSeries,
} from "../../../networks";
import TopStats from "./components/TopStats";
import { restructureToGroupArray } from "./helper";
import { usePageContextFunction } from "../../../context/PageContext";
import { EmptyStateWrapper } from "../../../components/molecules/v2/TimelineSection/TimelineSection.styled";
import Show from "../../../components/atoms/Show/Show";
import { ReactComponent as EmptyState } from "../../../components/molecules/v2/TimelineSection/assets/empty-state.svg";
// @ts-ignore
import { ReactComponent as EmptyStateDesktop } from "../../../components/molecules/v2/TimelineSection/assets/empty-state-desktop.svg";
import PointSupporterStateCard from "../../../components/atoms/CardStatistik/PoinSupporter";
import moment from "moment";
const KlasemenPertandinganSocPage = () => {
  const { size } = useWindowSize();
  // @ts-ignore
  const isMobileView = (size?.width || 0) <= 830;
  const { city } = useParams();
  const { setCity } = usePageContextFunction();
  const { search } = useLocation();
  const { data: dataRaw } = useFetchRegionEventSeries();

  const dataRegistCity = dataRaw?.data?.data?.eventSeries || [];

  const dataCityAttribute = dataRegistCity?.find(
    (val) =>
      String(val?.region_name)?.toLowerCase() === String(city)?.toLowerCase()
  );
  console.log({ dataCityAttribute });
  const currentDate = moment();
  const endDate = moment(dataCityAttribute?.event_end_date);

  const isWhitelistCity = ["lampung", "pontianak", "yogyakarta"].includes(city);
  const dataCityAttributeId = dataCityAttribute?.id;

  const { data: dataClassmentsDetailsRaw, isFetching } =
    useFetchClassmentsDetailsV2(dataCityAttributeId, dataCityAttribute?.length);
  const dataClassmentsDetail =
    restructureToGroupArray(dataClassmentsDetailsRaw?.data || {})?.data?.data ??
    [];

  React.useEffect(() => {
    // @ts-ignore
    setCity(city);
  }, [city]);

  if (isFetching) return <Loading />;

  return (
    <>
      <Section
        id="klasemen-pertandingan"
        height={"auto"}
        overflowY={"auto"}
        backgroundColor={"transparent"}
      >
        <ContentWrapper>
          <Show
            when={
              !dataClassmentsDetail?.filter(
                (segment) => segment?.stage_type_id === 1
              )?.length
            }
          >
            <EmptyStateWrapper style={{ marginTop: 30 }}>
              {isMobileView ? <EmptyState /> : <EmptyStateDesktop />}
            </EmptyStateWrapper>
          </Show>
          <Show
            when={
              dataClassmentsDetail?.filter(
                (segment) => segment?.stage_type_id === 1
              )?.length
            }
          >
            <InnerContentWrapper>
              {dataClassmentsDetail
                ?.filter((segment) => segment?.stage_type_id === 1)
                .map((val, index) => {
                  const title = val?.name;
                  const groupsData = [val];
                  return (
                    <div key={index} className="my-4">
                      <b className="text-white font-semibold text-[18px] block text-center mb-4">
                        {title}
                      </b>
                      <GroupTable
                        data={groupsData}
                        isWhitelistCity={isWhitelistCity}
                      />
                      {/* <TopStats /> */}
                    </div>
                  );
                })}
              <div className="flex gap-2 items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <circle cx="12" cy="12" r="12" fill="#77B341" />
                </svg>
                <span className="text-[#DDE2E8] font-semibold text-[18px]">
                  NB: Lolos tahap knockout
                </span>
              </div>
              {!isWhitelistCity ? (
                <div className="mt-6">
                  <PointSupporterStateCard text={"Top Scorer"} data={[]} />
                </div>
              ) : (
                <span className="text-[#DDE2E8] text-[18px] flex flex-row items-center mt-3">
                  <p className="font-semibold text-[18px] ml-1">OC Point</p>:
                  Opening Ceremony Point
                </span>
              )}
            </InnerContentWrapper>
          </Show>
        </ContentWrapper>
      </Section>
    </>
  );
};

export default KlasemenPertandinganSocPage;
